export const BLOG_UPDATED = "2026-11-02";
export const BLOG_UPDATED_LABEL = "November 2026";

const STOP = new Set(["in", "a", "the", "for", "of", "to", "are", "is", "how"]);
const clip = (s, n) => (s.length > n ? `${s.slice(0, n - 1).replace(/\s+\S*$/, "")}…` : s);
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);
const stem = (w) => w.replace(/-/g, " ").replace(/([^s])s$/, "$1");
export const kwTokens = (kw) => kw.toLowerCase().split(/\s+/).filter((w) => !STOP.has(w));
export const hasKeyword = (text, kw, ratio = 1) => {
  const hay = text.toLowerCase().replace(/-/g, " ").split(/[^a-z0-9]+/).map(stem);
  const toks = kwTokens(kw).map(stem);
  return toks.filter((w) => hay.includes(w)).length >= Math.ceil(toks.length * ratio);
};

const SEO_TITLES = {
  "fire-noc-delhi": "Fire NOC in Delhi: Who Needs It & the Process | Vinsafe",
  "evacuation-chair-fire-emergency": "Evacuation Chair Guide: Wheelchair & Elderly Evacuation",
  "fire-blanket-how-to-use": "Fire Blanket Guide: How to Use a Fire Blanket | Vinsafe",
  "fire-extinguisher-expiry-hydro-test-is-2190": "Fire Extinguisher Expiry Date & Hydro Test Rules (IS 2190)",
  "ev-charging-fire-safety-commercial-parking": "EV Charging Fire Safety for Offices, Malls & Parking",
  "emergency-exit-signs-photoluminescent-signage": "Fire Exit Signage & Photoluminescent Signs Guide | Vinsafe",
};

export const blogTitle = (b) => {
  if (SEO_TITLES[b.slug]) return SEO_TITLES[b.slug];
  const short = b.title.split(":")[0].trim();
  const natural = [`${b.title} | Vinsafe`, b.title, `${short} | Vinsafe`, short];
  const kwFirst = [`${cap(b.keyword)}: ${short} | Vinsafe`, `${cap(b.keyword)}: ${short}`, `${cap(b.keyword)} Guide for Businesses | Vinsafe`, `${cap(b.keyword)} | Vinsafe Guide`];
  const fits = (t) => t.length >= 30 && t.length <= 60;
  return natural.find((t) => fits(t) && hasKeyword(t, b.keyword, 0.75)) || kwFirst.find(fits) || clip(kwFirst[2], 60);
};

const SEO_METAS = {
  "fire-safety-hospitals-nursing-homes": "Hospitals cannot evacuate like offices. Learn the key fire safety equipment, evacuation methods and maintenance practices for hospitals and nursing homes.",
  "lithium-ion-battery-ev-fire-safety": "Lithium-ion batteries in EVs, e-bikes, UPS and storage burn unlike ordinary fires. What thermal runaway is and how to protect people and property.",
  "ev-charging-fire-safety-commercial-parking": "Staff and visitors want EV chargers; facility teams worry about fires. A practical fire safety plan for EV charging in office parks, malls and parking.",
};

export const blogMeta = (b) => {
  let m = SEO_METAS[b.slug] || b.meta;
  if (m.length > 160) {
    const sents = m.match(/[^.?!]+[.?!]/g) || [m];
    let s = "";
    for (const x of sents) { if ((s + x).length <= 160) s += x; else break; }
    m = s.trim().length >= 90 ? s.trim() : `${m.slice(0, 157).replace(/[\s,]+\S*$/, "").replace(/(\s+(and|or|for|to|of|in|the|a|how))+$/i, "")}.`;
  }
  for (const add of [" Step-by-step guide by Vinsafe, India.", " Updated for 2026.", " Free site survey for businesses."]) if (m.length < 120 && m.length + add.length <= 160) m += add;
  return m.length > 160 ? clip(m, 158) : m;
};

export const blogSummary = (b) => (hasKeyword(b.meta, b.keyword) ? `In short: ${b.meta}` : `Quick guide to ${b.keyword}: ${b.meta}`);
export const readMinutes = (b) => Math.max(2, Math.round(b.words / 200));

const crumbs = (site, items) => ({
  "@type": "BreadcrumbList",
  itemListElement: items.map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: `${site}${path}` })),
});

export const blogJsonLd = (site, b, image) => ({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "BlogPosting",
      headline: b.title.slice(0, 110),
      description: blogMeta(b),
      keywords: [b.keyword, ...b.secondary].join(", "),
      image: [image],
      datePublished: BLOG_UPDATED,
      dateModified: BLOG_UPDATED,
      inLanguage: "en-IN",
      wordCount: b.words,
      mainEntityOfPage: `${site}/blog/${b.slug}`,
      author: { "@type": "Organization", name: "Vinsafe", url: site },
      publisher: { "@type": "Organization", name: "Vinsafe", parentOrganization: { "@type": "Organization", name: "Vingrace Solutions Private Limited" } },
    },
    crumbs(site, [["Home", "/"], ["Blog", "/blog"], [b.title, `/blog/${b.slug}`]]),
    ...(b.faqs.length ? [{ "@type": "FAQPage", mainEntity: b.faqs.map(([q, a]) => ({ "@type": "Question", name: q, acceptedAnswer: { "@type": "Answer", text: a } })) }] : []),
  ],
});

export const blogIndexJsonLd = (site, blogs) => ({
  "@context": "https://schema.org",
  "@graph": [
    { "@type": "Blog", name: "Vinsafe Fire Safety Blog", url: `${site}/blog`, blogPost: blogs.map((b) => ({ "@type": "BlogPosting", headline: b.title.slice(0, 110), url: `${site}/blog/${b.slug}` })) },
    crumbs(site, [["Home", "/"], ["Blog", "/blog"]]),
  ],
});
